<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group" :class="[formClass, { error: errorClass }]">
		<input
			:type="type"
			v-model="model"
			:disabled="disabled"
			:maxlength="maxlength"
			:placeholder="placeholder"
			class="input w-full"
			autocomplete="off"
			tabindex="1"
			@focus="inputFocus"
			@blur="checkInput($event.target)"
		/>
		<span v-if="text" class="ml-2">{{ text }}</span>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { computed, watch, onMounted, ref } from "vue";

/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	type: String,
	title: String,
	text: String,
	formClass: [String, Array],
	maxlength: Number,
	placeholder: String,
	disabled: Boolean,
	required: Boolean,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");

/* ---------------------------------------------------------------------------
	modelValueの値を監視
---------------------------------------------------------------------------- */
watch(
	() => model.value,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */
function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	テキストタイプがnumberの場合、数値以外の文字列が入ったら削除
---------------------------------------------------------------------------- */
function checkInput(input) {
	if (props.type == "number") {
		let value = input.value;
		if (input.value === "") {
			input.type = "text";
			input.value = "";
		} else {
			value = value.replace(/[０-９]/g, s =>
				String.fromCharCode(s.charCodeAt(0) - 65248)
			);
			const numericValue = value;
			if (!isNaN(numericValue)) {
				model.value = numericValue.toString();
			} else {
				input.value = "";
				model.value = "";
			}
		}
	}
	titleActive.value = false;
}
/* ---------------------------------------------------------------------------
	捕捉事項の表示
---------------------------------------------------------------------------- */
function inputFocus() {
	titleActive.value = true;
}

/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(model.value);
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.input {
	height: 40px;
	font-size: 1.4rem;
	position: relative;
	font-weight: normal;
	@include trans(0.3);
	padding: 10px 6px 8px;
	border-radius: 5px;
	border: 1px solid $bg-gray2;
	&:focus {
		@include trans(0.3);
		border-color: $primaryColor;
		background-color: rgba(10, 186, 181, 0.2);
	}
	&.error {
		background-color: rgba(250, 183, 195, 0.3);
	}
	&-password {
		padding: 12px 25px 10px 6px;
	}
}
.input::placeholder {
	color: #d9d9d9;
}
input:disabled {
	color: $color-gray4;
	opacity: 1 !important;
	background: #eee;
}
.form_group {
	display: flex;
	align-items: flex-end;
}
.form_group.error .input {
	color: $baseTextColor;
	border-color: $bg-red2;
	background-color: rgba(250, 183, 195, 0.2);
}
</style>
